import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import ProjectStatus from '../views/ProjectStatus.vue';
import VirtualPublicHearing from '../views/VirtualPublicHearing.vue';
import About from '../views/About.vue';
import HomePage from '../views/HomePage.vue';
import ImageGallery from '../views/ImageGallery.vue';
import FAQs from '../views/FAQs.vue';
import GetInvolved from '../views/GetInvolved.vue';
import DocumentLibrary from '../views/DocumentLibrary.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: About,
  // },
  // {
  //   path: '/projectstatus',
  //   name: 'ProjectStatus',
  //   component: ProjectStatus,
  // },
  // {
  //   path: '/vph',
  //   name: 'VirtualPublicHearing',
  //   component: VirtualPublicHearing,
  // },
  // {
  //   path: '/imagegallery',
  //   name: 'ImageGallery',
  //   component: ImageGallery,
  // },
  // {
  //   path: '/getinvolved',
  //   name: 'GetInvolved',
  //   component: GetInvolved,
  // },
  // {
  //   path: '/faqs',
  //   name: 'FAQs',
  //   component: FAQs,
  // },
  {
    path: '/documentlibrary',
    name: 'DocumentLibrary',
    component: DocumentLibrary,
  },
  // Catch-all: any unknown path redirects to home
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      const selector = to.hash;
      const appBarOffset = 125; // header height in px
      // Try native selector first, but fall back to computed scroll if the element exists
      return new Promise((resolve) => {
        // allow Vue to render child components
        setTimeout(() => {
          const el = document.querySelector(selector) as HTMLElement | null;
          if (el) {
            const top = el.getBoundingClientRect().top + window.pageYOffset - appBarOffset;
            resolve({ x: 0, y: Math.max(0, Math.floor(top)) });
          } else {
            resolve({ selector });
          }
        }, 50);
      });
    }

    return { x: 0, y: 0 };
  },
});

export default router;
